module.exports = __webpack_public_path__ + "img/goods-posting-document.b0f82502.svg";